<template>
  <li
    class="col-xs-4"
    :class="{ active: boxConfig.trigger_button.kind === 'basic'}"
    @click="boxUpdateConfig({ item: 'trigger_button', key: 'kind', value: 'basic' })"
    >
    <a href="#" class="kp-btn-action-lg-max">
      <i class="kp-panel-btn-default"></i>
    </a>
    <div class="kp-tab-label">{{$t('general.labels.button')}}<br>{{$t('general.labels.standard')}}</div>
  </li>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  methods: mapActions([
    'boxUpdateConfig',
  ]),
  computed: mapGetters({
    boxConfig: 'boxConfig',
  }),
};
</script>



/** WEBPACK FOOTER **
 ** Basic.vue?9285639a
 **/